/**
 * Pure ref-count step for tests and predictable updates.
 */
export function adjustShortsContactModalPauseRefCount(
	current: number,
	isOpen: boolean
): number {
	if (isOpen) return current + 1;
	return Math.max(0, current - 1);
}

/**
 * When the contact modal, share UI (native sheet / desktop dropdown), or login modal
 * after a logged-out favorite tap opens on shorts, the reel should pause. Ref-count so
 * stacked surfaces unpause only when the last one closes.
 */
export function useShortsContactModalVideoPause() {
	const pauseRefCount = useState<number>(
		'shorts-contact-modal-video-pause-ref',
		() => 0
	);

	const isPausedBecauseContactModal = computed(() => pauseRefCount.value > 0);

	function notifyContactModalOpenChange(isOpen: boolean): void {
		pauseRefCount.value = adjustShortsContactModalPauseRefCount(
			pauseRefCount.value,
			isOpen
		);
	}

	return {
		isPausedBecauseContactModal,
		notifyContactModalOpenChange
	};
}
